


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/core/http/http.service';
import { AppConfig } from 'src/config/app-config.service';
import { User } from 'src/projects/registration/src/app/models/user';

@Injectable()
export class WelcomeService {

    constructor(private http: HttpService) {
    }

    public getCurrentUser(): Observable<User> {
        let getUserURL: string = AppConfig.settings.authenticationApi + AppConfig.settings.ApiSegments.getUser;
        return this.http.get(getUserURL)
    }

}